import { AxiosError } from "axios";

export default class BackendErrorEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {AxiosError} error 
     * @param {bool} failSilently 
     */
    constructor(type, error, failSilently) {
        this._type = type;
        this._error = error;
        this._failSilently = failSilently;
    }

    get type() {
        return this._type;
    }

    get error() {
        return this._error;
    }

    get failSilently() {
        return this._failSilently;
    }
}

BackendErrorEvent.ERROR = "BackendErrorEvent.ERROR";
BackendErrorEvent.CONTENT_FILTER_VIOLATION = "BackendErrorEvent.CONTENT_FILTER_VIOLATION";